import { useSupplierInboxOptional } from './InboxProvider';

const InboxSidebarCount = () => {
  const inbox = useSupplierInboxOptional();
  if (!inbox || inbox.count <= 0) return null;

  return (
    <span className="ml-auto inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-red-500 px-1.5 py-0.5 text-[10px] font-semibold leading-none text-white">
      {inbox.count > 99 ? '99+' : inbox.count}
    </span>
  );
};

export default InboxSidebarCount;
